import {
  BarChart as ReBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

export interface BarChartDataPoint {
  [key: string]: string | number | undefined;
}

export interface BarChartProps {
  data: BarChartDataPoint[];
  xKey: string;
  yKey: string;
  color?: string;
  height?: number;
  className?: string;
}

export function BarChart({
  data,
  xKey,
  yKey,
  color = "#FF6B00", // tracq-deep-orange
  height = 256,
  className,
}: BarChartProps) {
  return (
    <div
      className={`w-full bg-gray-900 rounded-lg p-4 ${className}`}
      style={{ height: `${height}px` }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <ReBarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid stroke="#374151" strokeDasharray="3 3" />
          <XAxis dataKey={xKey} stroke="#9CA3AF" fontSize={12} tickLine={false} axisLine={false} />
          <YAxis stroke="#9CA3AF" fontSize={12} tickLine={false} axisLine={false} />
          <Tooltip
            contentStyle={{
              backgroundColor: "#111827",
              border: "1px solid #374151",
              color: "#F9FAFB",
              borderRadius: "8px",
              boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
            }}
            labelStyle={{ color: "#D1D5DB" }}
          />
          <Bar
            dataKey={yKey}
            fill={color}
            radius={[4, 4, 0, 0]}
            className="hover:opacity-80 transition-opacity"
          />
        </ReBarChart>
      </ResponsiveContainer>
    </div>
  );
}
